import { mapToCommonStatusFbAccount, mapToCommonStatusWabaAccount, mapToCommonStatusOnBehalf, mapToLabelStatusFbAccount, mapToLabelStatusWabaAccount, } from "../admin/statuses";
var UNSET_LABEL = "unset";
var UIModelWabaAccounts = /** @class */ (function () {
    function UIModelWabaAccounts(response) {
        (this.total = response.total),
            (this.wabaAccounts = response.wabaAccounts.map(function (wabaAccount) { return new UIModelWabaAccount(wabaAccount); }));
    }
    return UIModelWabaAccounts;
}());
export { UIModelWabaAccounts };
var UIModelWabaAccount = /** @class */ (function () {
    function UIModelWabaAccount(response) {
        var _this = this;
        this.update = function (response) {
            _this.id = response.id;
            _this.partnerId = response.partnerId;
            _this.clientId = response.clientId;
            _this.externalId = response.externalId;
            _this.fbBusinessId = response.fbBusinessId;
            _this.debugError = response.debugError;
            _this.name = response.name;
            _this.namespace = response.namespace;
            _this.fbAccountStatus = response.fbAccountStatus;
            _this.onBehalfOfBusinessInfo = response.onBehalfOfBusinessInfo
                ? {
                    name: response.onBehalfOfBusinessInfo.name,
                    id: response.onBehalfOfBusinessInfo.id,
                    status: response.onBehalfOfBusinessInfo.status,
                    type: response.onBehalfOfBusinessInfo.type,
                }
                : null;
            _this.primaryFundingId = response.primaryFundingId;
            _this.status = response.status;
            _this.timezoneId = response.timezoneId;
            _this.modifiedAt = new Date(response.modifiedAt);
            _this.createdAt = new Date(response.createdAt);
            // this.wabaAccountSetupStatus = this.externalId ? "done" : "draft"
            _this.wabaAccountSetupStatus = _this.status;
            _this.consents = response.consents;
            _this.hasSignedConsents = response.hasSignedConsents;
            _this.settings = response.settings || null;
        };
        this.update(response);
    }
    Object.defineProperty(UIModelWabaAccount.prototype, "formValues", {
        get: function () {
            return {
                name: this.name,
                externalId: this.externalId,
                fbBusinessId: this.fbBusinessId,
                namespace: this.namespace,
                timezoneId: this.timezoneId,
                primaryFundingId: this.primaryFundingId,
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UIModelWabaAccount.prototype, "externalWabaAccountMappedStatus", {
        get: function () {
            return mapToCommonStatusWabaAccount[this.wabaAccountSetupStatus];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UIModelWabaAccount.prototype, "messageOnBehalfMappedStatus", {
        get: function () {
            var _a;
            return this.onBehalfOfBusinessInfo
                ? mapToCommonStatusOnBehalf[(_a = this.onBehalfOfBusinessInfo) === null || _a === void 0 ? void 0 : _a.status]
                : "draft";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UIModelWabaAccount.prototype, "fbBusinessVerificationMappedStatus", {
        get: function () {
            return mapToCommonStatusFbAccount[this.fbAccountStatus];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UIModelWabaAccount.prototype, "mainMappedStatus", {
        get: function () {
            var isAnySubssatusSetToFailed = [
                this.externalWabaAccountMappedStatus,
                this.messageOnBehalfMappedStatus,
                this.fbBusinessVerificationMappedStatus,
            ].some(function (status) { return status === "rejected"; });
            return isAnySubssatusSetToFailed
                ? "rejected"
                : mapToCommonStatusWabaAccount[this.status];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UIModelWabaAccount.prototype, "statuses", {
        get: function () {
            var _a;
            return {
                main: {
                    indicator: this.mainMappedStatus,
                    label: this.name,
                },
                externalWabaAccount: {
                    indicator: this.externalWabaAccountMappedStatus,
                    label: mapToLabelStatusWabaAccount(this.wabaAccountSetupStatus),
                },
                messageOnBehalf: {
                    indicator: this.messageOnBehalfMappedStatus,
                    label: ((_a = this.onBehalfOfBusinessInfo) === null || _a === void 0 ? void 0 : _a.status) || UNSET_LABEL,
                },
                fbBusinessVerification: {
                    indicator: this.fbBusinessVerificationMappedStatus,
                    label: mapToLabelStatusFbAccount[this.fbAccountStatus] || UNSET_LABEL,
                },
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UIModelWabaAccount.prototype, "isReadyToSubmit", {
        get: function () {
            return (this.fbBusinessId && this.timezoneId && this.mainMappedStatus !== "live");
        },
        enumerable: false,
        configurable: true
    });
    return UIModelWabaAccount;
}());
export { UIModelWabaAccount };
//# sourceMappingURL=data:application/json;base64,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